import React from 'react';
import TPBDownloads from '../components/TPBDownloads';
import { Link, useParams } from 'react-router-dom';
import { useLangTranslation } from '../utils/translation';
export default function Games() {
  const {lang='en'}=useParams();const t=useLangTranslation('games');
  return <section className="games-section">
    <div className="games-hero"><img src="/assets/tpb/tpb-formation.webp" alt="TPB" className="hero-bg"/><div className="hero-text"><p>EDGE GAMES</p><h1>{t('title')}</h1><p>{t('intro')}</p></div></div>
    <div className="games-title"><h2>{t('explore')}</h2><div className="underline"/></div>
    <div className="games-grid">
      <article className="game-card"><Link to={`/${lang}/tpb`} className="image-wrapper" aria-label="TPB"><img src="/assets/tpb/tpb-battle.webp" alt="TPB gameplay"/></Link><div className="content"><span className="game-status">{t('status')}</span><h3>TPB</h3><p className="tpb-full-name">Tactical Position Battle</p><p>{t('games.tpb.description')}</p><Link className="edge-text-link" to={`/${lang}/tpb`}>{t('explore')} →</Link><TPBDownloads /></div></article>
      <article className="game-future"><span className="game-future-mark">EDGE<span>+</span></span><h3>{t('futureTitle')}</h3><p>{t('futureDescription')}</p></article>
    </div>
  </section>;
}
